module.exports = {
  ANY: "any",
  CHILD: "child",
  SELF: "self",
};
